import ConfirmPopup from "./ConfirmPopup.component.jsx";

export default ConfirmPopup;